module.exports = __webpack_public_path__ + "static/media/logo.27cbedeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 348
// module chunks = 21